export default __webpack_public_path__ + "static/icons-f9b80019256011e2a9190dcb824cded4.svg";